import { NgModule } from '@angular/core';
import { IonicSelectableModule } from 'ionic-selectable';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { AddWorkflowPage } from './add-workflow.page';

import { DateSelectorModule } from '../shared/date-selector.module';

const routes: Routes = [
  {
    path: '',
    component: AddWorkflowPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicSelectableModule,
    IonicModule,
    DateSelectorModule,
    RouterModule.forChild(routes)
  ],
  declarations: [AddWorkflowPage]
})
export class AddWorkflowPageModule {}
